import { render, staticRenderFns } from "./approvel.vue?vue&type=template&id=56f8a85e"
import script from "./approvel.vue?vue&type=script&lang=js"
export * from "./approvel.vue?vue&type=script&lang=js"
import style0 from "./approvel.vue?vue&type=style&index=0&id=56f8a85e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports